import styled from 'styled-components';
import ConfirmPrintSvg from '../../../assets/onboardingNew/homepage/confirmation-print.svg';

const ConfirmPrintNewIcon = styled(ConfirmPrintSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2rem'};
height: ${props => props.height || '1.7rem'};
display: flex;
`;

export default ConfirmPrintNewIcon;
